import { useEffect, useState } from "react";
import { ArrowLeft, RefreshCw, ShieldCheck } from "lucide-react";
import { Button } from "../components/ui/button";
import { billingAPI } from "../lib/api";

export default function BillingReturnPage({ onBack }) {
  const [billing, setBilling] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    setLoading(true);
    try {
      const response = await billingAPI.subscription();
      setBilling(response.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { refresh(); }, []);

  const status = billing?.subscription_status || billing?.renewal_status || "pending";
  return <main className="min-h-screen bg-slate-50 px-6 py-10" data-testid="billing-return-page">
    <div className="mx-auto max-w-xl space-y-8">
      <Button data-testid="billing-return-back-button" variant="ghost" onClick={onBack}><ArrowLeft className="mr-2 h-4 w-4" />Torna alla dashboard</Button>
      <section className="border border-slate-200 bg-white p-8 shadow-sm">
        <ShieldCheck className="mb-4 h-8 w-8 text-emerald-700" />
        <h1 className="text-3xl font-bold text-slate-900">Stato pagamento Premium</h1>
        <p className="mt-3 text-slate-600" data-testid="billing-return-status">{loading ? "Verifica in corso…" : `Stato: ${status}`}</p>
        {!loading && billing?.current_period_end && <p className="mt-2 text-sm text-slate-500" data-testid="billing-return-period">Accesso valido fino al {new Date(billing.current_period_end).toLocaleDateString("it-IT")}</p>}
        <Button data-testid="billing-return-refresh-button" className="mt-6 bg-emerald-700 text-white hover:bg-emerald-800" onClick={refresh} disabled={loading}>
          <RefreshCw className="mr-2 h-4 w-4" />Aggiorna stato
        </Button>
      </section>
    </div>
  </main>;
}